import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { withTheme } from 'providers/Theme.provider';
import {
  selectCurrentSalon,
  selectCurrentSalonId,
  selectCurrentSalonOnlineBooking,
} from 'selectors/currentSalon.selectors';

import NoBillingModal from 'settings/online-booking/modals/NoBillingModal';
import SetUpView from 'settings/online-booking/SetUpView';

class OnlineBookingSetup extends React.Component {
  constructor(props) {
    super(props);

    let activateOnlineBooking = true;
    if (this.props.currentSalon && props.currentSalon.online_booking) {
      activateOnlineBooking = false;
    }

    this.state = {
      activateOnlineBooking,
      billingPopupOpen: false,
    };
  }

  componentDidMount() {
    this.onClickButtonGo();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.currentSalon && nextProps.currentSalon) {
      if (nextProps.currentSalon.online_booking !== this.state.activateOnlineBooking) {
        this.setState({ activateOnlineBooking: !nextProps.currentSalon.online_booking });
      }
    }
  }

  onClickButtonGo = () => {
    this.setState({ activateOnlineBooking: false });
  };

  beforeSetOnline = () => {
    const { has_billing: hasBilling } = this.props.currentSalon;
    if (!hasBilling) {
      this.showPopup('billingPopupOpenbillingPopupOpen');
      this.setState({ billingPopupOpen: true });
    }
  };

  showPopup = (popup) => {
    this.setState({ [popup]: true });
  };

  closePopup = () => {
    this.setState({ billingPopupOpen: false });
  };

  render() {
    const { isBrightMode, isDarkMode, isLightMode } = this.props;

    return (
      <div
        data-bem="OnlineBookingSetup"
        className={cn({
          settings: true,
          'light-class': isLightMode,
          'dark-class': isDarkMode,
          'bright-class': isBrightMode,
        })}
      >
        <div className="online-booking">
          {!this.state.activateOnlineBooking && this.props.currentSalon && (
            <div>
              <SetUpView
                salonId={this.props.salonId}
                history={this.props.history}
                beforeSetOnline={this.beforeSetOnline}
                has_billing={this.props.currentSalon.has_billing}
              />
            </div>
          )}
        </div>

        <NoBillingModal
          isOpen={this.state.billingPopupOpen}
          onClose={() => void this.setState({ billingPopupOpen: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentSalon: selectCurrentSalon(state),
  salonId: selectCurrentSalonId(state),
  online_booking: selectCurrentSalonOnlineBooking(state),
});

const OnlineBookingSetupHoc = connect(mapStateToProps)(withTheme({ hasBright: true })(OnlineBookingSetup));

export default OnlineBookingSetupHoc;
